import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  activeADGroup: null,
};

/**
 * Intended to store user's AD groups information
 * Use case: handle "super user" group, details there https://jira.mynmg.com/browse/OSP-4228
 */
const userGroups = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_ACTIVE_USER_AD_GROUP:
      return {
        ...state,
        activeADGroup: payload,
      };
    case actionTypes.RESET_ACTIVE_USER_AD_GROUP:
      return {
        ...state,
        activeADGroup: null,
      };
    default:
      return state;
  }
};

export default userGroups;
